import { render } from "./FooterOrderDetails.vue?vue&type=template&id=29f8801c"
import script from "./FooterOrderDetails.vue?vue&type=script&lang=js"
export * from "./FooterOrderDetails.vue?vue&type=script&lang=js"

import "./FooterOrderDetails.vue?vue&type=style&index=0&id=29f8801c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__